import React from 'react';

export default class NotifService extends React.Component {
	 render() {
    	const { children } = this.props;
    	return <div style={{ flex: 1 }}>{children}</div>;
	 }
}